import axios from 'axios';
import Loader from '../../../../library/intranet/loader';
import {errorHandler, XHR_STATUS_DEFAULT} from '../../../../utils/portuna';

const updateInterval = 300 * 1000;

let index = {
    namespaced: true,
    state: {
        lastUpdate: 0,
        dashboardLastUpdate: 0,
        widgets: null,
        widgetsFailed: false,
        dashboardWidgets: null,
        dashboardWidgetsFailed: false,
        currentActivity: null,
        moduleIcons: {},
        moduleAdmin: false,
    },
    getters: {
        activeWidgets(state)
        {
            return state.widgets.filter((data) => data.widget.active);
        },
        dashboardWidgets(state)
        {
            return state.dashboardWidgets;
        },
        inactiveWidgets(state)
        {
            return state.widgets.filter((data) => !data.widget.active);
        },
    },
    actions: {
        fetch({commit, state})
        {
            if (state.lastUpdate !== 0 && Date.now() - state.lastUpdate < updateInterval)
            {
                return;
            }

            commit('setWidgetError', false);

            return axios.get('/application/application/fetch-widgets').then((response) => commit('setWidgets', response.data.data)).catch(() =>
            {
                commit('setWidgetError', true);
            });
        },
        fetchDashboard({commit, state})
        {
            if (state.dashboardLastUpdate !== 0 && Date.now() - state.dashboardLastUpdate < updateInterval)
            {
                return;
            }

            commit('setDashboardWidgetsError', false);

            return axios.get('/application/application/fetch-dashboard-widgets').then((response) => commit('setDashboardWidgets', response.data.data)).catch(() =>
            {
                commit('setDashboardWidgetsError', true);
            });
        },
        widgetChangeStatus({commit, state}, payload)
        {
            Loader.show('Widgets werden gespeichert...');
            return axios.post('/application/application/widget-change-status', payload).then((response) =>
            {
                if (response.data.status === XHR_STATUS_DEFAULT)
                {
                    commit('widgetSetActive', payload);
                }
                else
                {
                    errorHandler(response.data);
                }
            }).catch(errorHandler).finally(() => Loader.hide());
        },
        /*widgetSaveOrder({commit, state})
        {
            let position = {};
            for (let widgetData of state.widgets)
            {
                position[widgetData.widget.id] = {
                    id: widgetData.widget.id,
                    active: widgetData.widget.active,
                    position: widgetData.widget.position,
                };
            }

            position = Object.values(position).sort((a, b) => a.position < b.position ? -1 : 1).map((widget) =>
            {
                delete widget.position;

                return widget;
            });

            Loader.show('Widgets werden gespeichert...');
            axios.post('/application/application/widgets-save', {position}).then((response) =>
            {
                if (response.data.status === XHR_STATUS_DEFAULT)
                {
                    commit('setWidgetActive');
                }
                else
                {
                    errorHandler(response.data);
                }
            }).catch(errorHandler).finally(() => Loader.hide());
        },*/
    },
    mutations: {
        widgetSetActive(state, payload)
        {
            for (let widgetData of state.widgets)
            {
                if (widgetData.widget.id === payload.id)
                {
                    widgetData.widget.active = payload.active;
                    if (typeof payload.position !== 'undefined')
                    {
                        widgetData.widget.position = payload.position;
                    }
                    break;
                }
            }
        },
        setWidgetError(state, status)
        {
            state.widgetsFailed = status;
        },
        setDashboardWidgetsError(state, status)
        {
            state.dashboardWidgetsFailed = status;
        },
        setModuleIcons(state, payload)
        {
            state.moduleIcons = payload;
        },
        setModuleAdmin(state, payload)
        {
            state.moduleAdmin = payload;
        },
        setWidgets(state, payload)
        {
            state.lastUpdate = Date.now();
            state.widgets    = payload || [];
        },
        setDashboardWidgets(state, payload)
        {
            state.dashboardLastUpdate = Date.now();
            state.dashboardWidgets = payload || [];
        },
        setCurrentActivity(state, current)
        {
            state.currentActivity = current;
        },
    }
};

export default index;